export default __webpack_public_path__ + "images/9bf87b7225e958a786a809fd8fcd39aa-location.svg";